import { IonButton, IonIcon } from '@ionic/react';
import { chevronBack, chevronForward } from 'ionicons/icons';

interface MatchWeekNavigatorProps {
  currentWeekNumber: number;
  hasPrevious: boolean;
  hasNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
}

export const MatchWeekNavigator = ({
  currentWeekNumber,
  hasPrevious,
  hasNext,
  onPrevious,
  onNext,
}: MatchWeekNavigatorProps) => {
  const handlePrevious = () => {
    if (hasPrevious) {
      onPrevious();
    }
  };

  const handleNext = () => {
    if (hasNext) {
      onNext();
    }
  };

  return (
    <div className="flex items-center justify-between px-4 py-2 bg-gray-100 border-b border-gray-200">
      <IonButton
        fill="clear"
        disabled={!hasPrevious}
        onClick={handlePrevious}
        data-testid="previous-week-button"
      >
        <IonIcon icon={chevronBack} slot="icon-only" />
      </IonButton>
      <span className="text-lg font-semibold" data-testid="week-number">
        Jornada {currentWeekNumber}
      </span>
      <IonButton
        fill="clear"
        disabled={!hasNext}
        onClick={handleNext}
        data-testid="next-week-button"
      >
        <IonIcon icon={chevronForward} slot="icon-only" />
      </IonButton>
    </div>
  );
};
